// extracted by mini-css-extract-plugin
module.exports = {"menu":"styles_menu__ZawBU","icon":"styles_icon__tUvZU","iconTransformed":"styles_iconTransformed__l1FPA"};
module.exports.__checksum = "c9470dcd85a9"
